import React, { useEffect, useState } from "react";
import CustomButtonOval from "../../components/form/CustomButtonOval";
import { clientsResource } from "../../helpers/configRoutes/backend_helper";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import AddUpdClientModal from "./AddUpdClientModal";
import Columns from "./Columns";
import DataTableElement from "../../components/elements/DataTableElement";
import FiltersPagination from "../../components/elements/FiltersPagination";
import { useSearchParams } from "react-router-dom";

const Clients = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [modalConfirm, setModalConfirm] = useState({
        show: false,
        title: 'Delete client',
        loading: false,
        textLoad: 'Processing'
    });

    const [filters, setFilters] = useState({
        perPage: 10,
        page: 1,
        search: ''
    });

    const [meta, setMeta] = useState({
        total: 0,
        current_page: 0
    });

    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: 'Loading clients...'
    });

    const [clients, setClients] = useState([]);
    const [client, setClient] = useState({ id: null });
    const [modal, setModal] = useState({ show: false });

    useEffect(() => {
        const fetchClients = async () => {
            setTableLoad({ ...tableLoad, show: true });
            const response = await clientsResource('get', { params: filters });
            setClients(response.companies);
            setMeta(response.meta);
            setTableLoad({ ...tableLoad, show: false });
        };
        fetchClients();
    }, [filters]);

    useEffect(() => {
        const editId = searchParams.get('edit');

        if (!editId || !clients.length || modal.show) return;

        const selectedClient = clients.find(item => String(item.id) === String(editId));

        if (!selectedClient) return;

        openModalAdd(selectedClient);
        setSearchParams({}, { replace: true });
    }, [clients, searchParams, modal.show]);

    const openModalAdd = (client = {}) => {
        setClient(client);
        setModal({
            ...modal,
            show: true,
            title: client.id ? "Edit Client" : "Add Client"
        });
    };

    const deleteCompany = async () => {
        setModalConfirm({ ...modalConfirm, loading: true });
        const response = await clientsResource('del', {}, modalConfirm.id);
        if (response.status) {
            setFilters({ ...filters });
        }
        setModalConfirm({
            ...modalConfirm,
            loading: false,
            show: false,
            id: null
        });
    };

    const cols = Columns(setModalConfirm, modalConfirm, openModalAdd);

    return (
        <>
            <div className="p-2 bg-gray-100 min-h-screen">

                {/* ===== HEADER ===== */}
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">
                            Clients
                        </h1>
                        <p className="text-sm text-gray-500">
                            Manage your clients and their information
                        </p>
                    </div>

                    <CustomButtonOval onClick={() => openModalAdd({ id: null })}>
                        + New Client
                    </CustomButtonOval>
                </div>

                {/* ===== CARD TABLE ===== */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200">
                    <FiltersPagination
                        filters={filters}
                        setFilters={setFilters}
                        meta={meta}
                        showFilters={true}
                        showPlanFilter={false}
                        showStatusFilter={false}
                    >
                        <DataTableElement
                            columns={cols}
                            tableLoad={tableLoad}
                            items={clients}
                        />
                    </FiltersPagination>
                </div>
            </div>

            {/* ===== MODALS ===== */}
            <AddUpdClientModal
                clientItem={client}
                modal={modal}
                setModal={setModal}
                filters={filters}
                setFilters={setFilters}
            />

            <ConfirmDeleteModal
                modal={modalConfirm}
                setModal={setModalConfirm}
                action={deleteCompany}
            />
        </>
    );
};

export default Clients;
